import User from '@/models/user'

export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0,
    user: {}
  },
  actions: {
    async read ({ commit, dispatch, state }) {
      return dispatch('read', { modelClass: User }, { root: true })
        .then(response => {
          localStorage.setItem('userId', response.id)
          state.user = response
          commit('SET_MANAGER_PERMISSIONS', response.userprofile, {root: true})
          return response
        })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, data) {
      return dispatch('updateUser', { modelClass: User, data: data }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async list ({ dispatch, state }) {
      return dispatch('request', { method: 'get', url: 'user-profiles' }, { root: true })
        .then(response => { return response.data })
        .catch(error => { throw error })
    },
    async readUserConfig ({ dispatch, state }) {
      return dispatch('request', { method: 'get', url: 'user-profiles/' + localStorage.getItem('userId') }, { root: true })
        .then(response => { return response.data })
        .catch(error => { throw error })
    },
    async saveUserConfig ({ dispatch, state }, data) {
      return dispatch('partialUpdate', { url: 'user-profiles', data: data, id: data.id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    }/*
    async saveUserConfig ({ dispatch, state }, data) {
      return dispatch('save', { url: 'user-profiles', data: data, id: data.id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    } */
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js